import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import SuccessModal from "../SuccessModal";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import {
  getStoreByWarehouseInfo,
  getWarehouseGarmentsByStatus,
  postSendToStore,
  toGenerateChallanFromWarehouse,
} from "../../services/warehouse/WarehouseProcess";
import ConfirmStoreChange from "./ConfirmStoreChange";

const ReadyToSendToStoreByWarehouse = () => {
  const navigate = useNavigate();
  const { warehouseData } = getUserData();

  let warehouseId = warehouseData.id;
  const [modalVisible, setModalVisible] = useState(false);
  const [qrCodes, setQrCodes] = useState({});
  const [selectedQrCodes, setSelectedQrCodes] = useState([]);
  const [selectedQrCodesChecked, setSelectedQrCodesChecked] = useState([]);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [storeList, setStoreList] = useState([]);
  const [storeValue, setStoreValue] = useState("");
  const [isSendButtonPressed, setIsSendButtonPressed] = useState(false);
  const [loading, setLoading] = useState(true);

  const [searchTerm, setSearchTerm] = useState("");

  const [dataProvider, setDataProvider] = useState([]);
  const [dataProviderSuggestion, setDataProviderSuggestion] = useState([]);

  const [confirmStoreChangeModalVisible, setConfirmStoreChangeModalVisible] =
    useState(false);

  let qrCodeMap = new Map();
  const fetchData = (data) => {
    getWarehouseGarmentsByStatus(warehouseId, data)
      .then((response) => {
        if (!response.data.error) {
          response.data.forEach((element) => {
            let garmentInfo = {
              garmentName: element.garmentName,
              id: element.id,
            };
            qrCodeMap.set(element.qrCode, garmentInfo);
          });
          setQrCodes(qrCodeMap);
          const suggestions = [];
          qrCodeMap.forEach((garment, qrCode) => {
            if (qrCode.toLowerCase().startsWith(searchTerm.toLowerCase())) {
              suggestions.push({ qrCode, garment });
            }
          });

          const newQrCodes = suggestions.filter(
            (item) => !selectedQrCodesChecked.includes(item.qrCode)
          );

          const updatedSelectedQrCodes = [
            ...selectedQrCodes,
            ...newQrCodes.map((item) => ({
              garmentName: item.garment.garmentName,
              id: item.garment.id,
              qrCode: item.qrCode,
            })),
          ];

          setSelectedQrCodes(updatedSelectedQrCodes);
          setDataProvider(updatedSelectedQrCodes);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchStoreData = () => {
    getStoreByWarehouseInfo(warehouseId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const storeData = response.data.map((item) => ({
            name: item.store.storeName,
            value: item.id, // store.id
          }));
          setStoreList(storeData);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchStoreData();
  }, []);

  const receiveDataFromConfirmModal = ({ success }) => {
    if (success) {
      setSelectedQrCodes([]);
      setSelectedQrCodesChecked([]);
      setDataProviderSuggestion([]);
      setSearchTerm("");
      setStoreValue("");
    }
  };

  const handleStoreChange = (selectedItem) => {
    if (selectedQrCodes.length > 0) {
      setConfirmStoreChangeModalVisible(true);
    } else {
      setStoreValue(selectedItem);
      const data = {
        status: ["READY_TO_SEND_TO_STORE_BY_WARE_HOUSE"],
        storeWareHouseIds: [selectedItem],
      };
      fetchData(data);
    }
  };

  const handleSendToStore = () => {
    // Check if the button has already been pressed
    if (!isSendButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsSendButtonPressed(true);
      toGenerateChallanFromWarehouse(storeValue)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            const data = {
              qrCodeInfoList: selectedQrCodes.map((item) => ({
                id: item.id,
              })),
              wareHouseStoreChallanDTO: response.data,
            };
            postSendToStore(warehouseId, data)
              .then((response) => {
                if (!response.data.error) {
                  const Res = response.data;
                  const message = Res.message;
                  const success = Res.status;
                  if (success === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setTimeout(() => {
                      navigate("/");
                    }, 1500);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                  }
                }
              })
              .catch((err) => {
                console.error("Error:", err);
              });
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    }
  };

  const rowRenderer = () => {
    return dataProvider?.map((item, index) => (
      <div
        key={index}
        className="flex flex-row py-1 mx-2 justify-content-between"
      >
        <p className="flex-1 text-lg font-normal ">{item.qrCode}</p>
        <p className="flex-1 text-lg font-normal ">
          {(item.garmentName.replace(/_/g, " ") + "").substring(0, 20)}
          {(item.garmentName + "").length > 20 ? "..." : ""}
        </p>
      </div>
    ));
  };

  const handleBackButton = () => {
    navigate("/");
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => handleBackButton()}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-2xl text-white font-bold capitalize">
                Ready To Send To Store
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-1 ">
        <div className="flex-1">
          <div className="flex-1 flex flex-column justify-content-center align-items-center" style={{ pointerEvents: isSendButtonPressed ? "none" : "auto" }}>
            <div className="w-full ">
              <div className="mx-2 mt-2">
                <Dropdown
                  value={storeValue}
                  onChange={(e) => handleStoreChange(e.value)}
                  options={storeList}
                  placeholder="Select Store"
                  disabled={isSendButtonPressed}
                  optionLabel="name"
                  className="w-full  bg-white-alpha-20 border-round-xl text-2xl text-primary-50"
                />
              </div>
            </div>

            {storeValue === "" && (
              <div>
                <p className=" text-3xl mt-3 font-bold text-center">
                  Please select the store
                </p>
              </div>
            )}
          </div>
          {storeValue !== "" && (
          <div className=" flex-1">
            <div>
              <div className="flex-1">
                <div className="flex-1">
                  <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                    <p className="w-full text-3xl  font-bold text-start">
                      Garments Tag List
                    </p>
                  </div>
                </div>

                {selectedQrCodes.length === 0 ? (
                  <div>
                    <p className=" text-3xl  font-bold text-center">
                      Please Select Tag
                    </p>
                  </div>
                ) : (
                  <div>
                    <div className="flex flex-row py-1 mx-2 justify-content-between">
                      <p className="flex-1 text-2xl font-medium ">Tag</p>
                      <p className="flex-1 text-2xl font-medium">Garment</p>
                    </div>
                    <div>
                      <div style={{ overflowY: "auto", height: "60vh" }}>
                        {rowRenderer()}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <ConfirmStoreChange
                setConfirmStoreChangeModalVisible={
                  setConfirmStoreChangeModalVisible
                }
                confirmStoreChangeModalVisible={confirmStoreChangeModalVisible}
                sendDataToConfirmStoreChange={receiveDataFromConfirmModal}
              />
              <SuccessModal
                setModalVisible={setModalVisible}
                modalVisible={modalVisible}
                status={modalStatus}
                text={modalText}
              />
            </div>
            {selectedQrCodes.length > 0 && (
              <div
                className="my-1 mx-2"
                style={{ pointerEvents: isSendButtonPressed ? "none" : "auto" }}
              >
                <div className="flex-1 mx-2 mb-1 mt-2 sticky z-2 bottom-0">
                  <div className=" flex justify-content-center">
                    <Button
                      onClick={handleSendToStore}
                      disabled={isSendButtonPressed}
                      className="flex justify-content-center text-2xl w-full border-round-xl border-none cursor-pointer"
                    >
                      <p className="text-xl font-bold text-white text-center">
                        {isSendButtonPressed ? "Sending..." : "Send"}
                      </p>

                      <div className="flex justify-content-center ml-5 relative">
                        <img
                          src={
                            "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                          }
                          style={{ width: 30 }}
                        />
                        <div
                          style={{
                            left: 28,
                            position: "absolute",
                            top: -10,
                            backgroundColor: "red",
                            borderRadius: 20,
                            minWidth: 36,
                            height: 36,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <p className=" text-md  font-normal text-center">
                            {selectedQrCodes.length}
                          </p>
                        </div>
                      </div>
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        </div>
        
      </div>
    </div>
  );
};

export default ReadyToSendToStoreByWarehouse;
